import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=d80658f0&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=ts"
export * from "./Cover.vue?vue&type=script&lang=ts"
import style0 from "./Cover.vue?vue&type=style&index=0&id=d80658f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80658f0",
  null
  
)

export default component.exports